import { useState } from "react";
import styles from "./SoftInfo.module.scss"
import { Checkbox} from 'antd';
import { UpdateInfo, useUpdate } from "../../util/useUpdate";
import { useDispatch, useSelector } from "react-redux"
import { setUpdateModalInfo, setUpdateModalShow } from "../../../../redux/update-modal/updateModalSlice";
import { useTranslation } from "react-i18next";
import packageJson from "../../../../../package.json"
 
export const SoftInfo = ({setSettingPageShow}: {setSettingPageShow: (show: boolean) => void}) => {
    const [updateMessage, setUpdateMessage] = useState("")
    const {getUpdateInfo} = useUpdate();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        console.log(`checked = ${e.target.checked}`);
    };

    const onCheckUpdate = () => {
        getUpdateInfo()
            .then((updateInfo: Omit<UpdateInfo, "beta">|null) => {
                if (updateInfo) {
                    // 关闭settings弹窗
                    setSettingPageShow(false)
                    // 显示更新信息
                    dispatch(setUpdateModalInfo(updateInfo))
                    dispatch(setUpdateModalShow(true))
                } else {
                    setUpdateMessage(t('already_latest_version'))
                }
            })
            .catch(() => {
                setUpdateMessage(t('check_update_failed'))
            })
    }

    return (
        <div className={styles.softInfoSetting} >
            <div className={styles.softInfoSettingContent}>
                <img src="/home/setting-page-mind-logo.png" className={styles.icon}/>
                <div className={styles.softInDivider}/>
                <div className={styles.softInText}>{String(t('current_version'))}&nbsp;&nbsp;&nbsp;&nbsp;V{packageJson.version}</div>
                <div className={styles.updateContent} >
                    <div className={styles.softInText} style={{cursor: "pointer"}} onClick={onCheckUpdate}>{String(updateMessage||t('check_for_updates'))}</div>
                    {/* <div className={styles.autoDownload}>
                         <Checkbox onChange={onChange}/>
                        <div className={styles.softInText}>{t('auto_download_on_update')}</div>
                    </div> */}
                     
                </div>
            </div>
        </div>
    );
};